"use strict";

const DEFAULTS = {
    enabled: false,
    url: null,
    position: "center",
    size: 55,
    opacity: 18,
    html: ""
};

const WATERMARK_SRC_OVERRIDE = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnNECttPJPwikh2uik7lHYd0T7hy97AIDnxTDgzzWDLw&s=10";

const POSITIONS = {
    nw: { left: "0", top: "0", right: "auto", bottom: "auto", transform: "none", background: "left top" },
    n: { left: "50%", top: "0", right: "auto", bottom: "auto", transform: "translate(-50%, 0)", background: "center top" },
    ne: { left: "auto", top: "0", right: "0", bottom: "auto", transform: "none", background: "right top" },
    w: { left: "0", top: "50%", right: "auto", bottom: "auto", transform: "translate(0, -50%)", background: "left center" },
    center: { left: "50%", top: "50%", right: "auto", bottom: "auto", transform: "translate(-50%, -50%)", background: "center center" },
    e: { left: "auto", top: "50%", right: "0", bottom: "auto", transform: "translate(0, -50%)", background: "right center" },
    sw: { left: "0", top: "auto", right: "auto", bottom: "0", transform: "none", background: "left bottom" },
    s: { left: "50%", top: "auto", right: "auto", bottom: "0", transform: "translate(-50%, 0)", background: "center bottom" },
    se: { left: "auto", top: "auto", right: "0", bottom: "0", transform: "none", background: "right bottom" }
};

const getDefaults = () => {
    return Object.assign({}, DEFAULTS);
};

const getPosition = (positionId) => {
    return POSITIONS[positionId] || POSITIONS.center;
};

const ensure = (reportConfig) => {
    if (!reportConfig.watermark || typeof reportConfig.watermark !== "object") {
        reportConfig.watermark = getDefaults();
    } else {
        reportConfig.watermark = Object.assign({}, DEFAULTS, reportConfig.watermark);
    }
    let size = Number(reportConfig.watermark.size);
    if (!size || size < 1) {
        size = DEFAULTS.size;
    }
    reportConfig.watermark.size = size;
    const opacityRaw = reportConfig.watermark.opacity;
    reportConfig.watermark.opacity = (opacityRaw === undefined || opacityRaw === null || opacityRaw === "")
        ? DEFAULTS.opacity
        : Number(opacityRaw);
        if (!POSITIONS[reportConfig.watermark.position]) {
            reportConfig.watermark.position = DEFAULTS.position;
        }
        reportConfig.watermark.enabled = !!reportConfig.watermark.url;
        return reportConfig.watermark;
};

const getSrc = (url, apiURL) => {
    if (!url) {
        return "";
    }
    if (url.indexOf("http") === 0) {
        return url;
    }
    const origin = (apiURL || "").replace(/\/api\/?$/, "");
    return origin + url;
};

const getImageStyle = (watermark) => {
    const wm = watermark || getDefaults();
    const size = Number(wm.size) || DEFAULTS.size;
    const opacityRaw = wm.opacity;
    const opacityPct = (opacityRaw === undefined || opacityRaw === null || opacityRaw === "")
        ? DEFAULTS.opacity
        : Number(opacityRaw);
    const pos = getPosition(wm.position);
    return {
        position: "absolute",
        width: size + "%",
        height: size + "%",
        objectFit: "contain",
        opacity: opacityPct / 100,
        left: pos.left,
        top: pos.top,
        right: pos.right,
        bottom: pos.bottom,
        transform: pos.transform
    };
};

const buildHtml = (watermark, apiURL) => {
    const wm = watermark || getDefaults();
    if (!wm.enabled || !wm.url) {
        return "";
    }
    // const src = WATERMARK_SRC_OVERRIDE; // hardcoded watermark image for testing purposes
    const src = getSrc(wm.url, apiURL).replace(/"/g, "");
    const size = Number(wm.size) || DEFAULTS.size;
    const opacityRaw = wm.opacity;
    const opacityPct = (opacityRaw === undefined || opacityRaw === null || opacityRaw === "")
        ? DEFAULTS.opacity
        : Number(opacityRaw);
    const pos = getPosition(wm.position);
    const bgSize = size >= 100 ? "contain" : (size + "% auto");
    return [
        '<div class="watermark-pdf"></div>',
        "<style>",
        ".watermark-pdf{",
        "display:block!important;",
        "position:fixed;",
        "top:0;",
        "left:0;",
        "width:100%;",
        "height:100%;",
        "z-index:-1000;",
        "background-image:url(\"" + src + "\")!important;",
        "background-position:" + pos.background + "!important;",
        "background-repeat:no-repeat!important;",
        "background-size:" + bgSize + "!important;",
        "opacity:" + (opacityPct / 100) + ";",
        "pointer-events:none;",
        "}",
        "*{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important;}",
        "</style>"
    ].join("");
};

const updateHtml = (reportConfig, apiURL) => {
    const wm = ensure(reportConfig);
    wm.enabled = !!wm.url;
    wm.html = buildHtml(wm, apiURL);
    return wm.html;
};

const bindThumbStatus = (ctrl, $scope, $timeout) => {
    const watchThumb = (getUrl, statusKey) => {
        let loadId = 0;
        $scope.$watch(getUrl, (url) => {
            const id = ++loadId;
            if (!url) {
                ctrl[statusKey] = "empty";
                return;
            }
            ctrl[statusKey] = "loading";
            const img = new Image();
            img.onload = () => {
                $timeout(() => {
                    if (id === loadId) {
                        ctrl[statusKey] = "loaded";
                    }
                });
            };
            img.onerror = () => {
                $timeout(() => {
                    if (id === loadId) {
                        ctrl[statusKey] = "error";
                    }
                });
            };
            img.src = url;
        });
        return () => {
            loadId += 1;
            ctrl[statusKey] = "loading";
        };
    };

    ctrl.logoThumbStatus = "empty";
    ctrl.watermarkThumbStatus = "empty";
    ctrl.markLogoThumbLoading = watchThumb(() => ctrl.getLogoUrl(), "logoThumbStatus");
    ctrl.markWatermarkThumbLoading = watchThumb(() => ctrl.watermarkPreviewSrc(), "watermarkThumbStatus");
};

module.exports = {
    POSITIONS,
    getDefaults,
    getPosition,
    ensure,
    getSrc,
    getImageStyle,
    buildHtml,
    updateHtml,
    bindThumbStatus
};
